import { PackagingComponentEntryDto } from "./packaging-component-entry-dto";

export class DecorationEntryDto extends PackagingComponentEntryDto {
  removedBeforeUsage: boolean | null = null;
  removedByConsumer: boolean | null = null;
  separationThroughCollectionAndSorting: boolean | null = null;
  surfaceRatio?: number;
}
